import { ConsumptionState, CustomAction } from "model/state";
import { ConsumptionPeriod, getDateRange, IntervalType, UnitFormat, UnitSystem } from "model";
import { ConsumptionPayload } from "actions";
import {
  CLEAN_CONSUMPTION_DATA, FETCH_CONSUMPTION_BY_FILTERS, FETCH_CONSUMPTION_BY_FILTERS_ERROR,
  FETCH_CONSUMPTION_BY_FILTERS_SUCCESS, FETCH_CONSUMPTION_BY_LOCATION, FETCH_CONSUMPTION_BY_LOCATION_SUCCESS,
  UPDATE_CONSUMPTION_FILTER,
} from "constants/ActionTypes";


const initialState: ConsumptionState = {
  selectedPeriod: ConsumptionPeriod.TODAY,
  data: {
    items: [],
    metadata: {
      unit: UnitSystem.IMPERIAL,
      short: UnitFormat.displayShortVolumeUnit(UnitSystem.IMPERIAL),
      long: UnitFormat.displayLongVolumeUnit(UnitSystem.IMPERIAL),
      timezone: 'UTC'
    }
  },
  intervalType: IntervalType.HOURS,
  filters: {
    locations: [],
    dateRange: getDateRange(IntervalType.HOURS)
  },
  isLoading: false,
};


function consumptionReducer(state: ConsumptionState | undefined = initialState, action: CustomAction<ConsumptionPayload>) {
  switch (action.type) {
    case FETCH_CONSUMPTION_BY_LOCATION: {
      return {
        ...state,
        selectedPeriod: action.payload?.period !== undefined ? action.payload.period : ConsumptionPeriod.TODAY,
      }
    }

    case FETCH_CONSUMPTION_BY_FILTERS: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case FETCH_CONSUMPTION_BY_FILTERS_SUCCESS:
    case FETCH_CONSUMPTION_BY_LOCATION_SUCCESS: {
      return {
        ...state,
        data: action.payload?.consumptionData !== undefined ? action.payload?.consumptionData : initialState.data,
        intervalType: action.payload?.intervalType !== undefined ? action.payload?.intervalType : initialState.intervalType,
        isLoading: false,
      }
    }

    case FETCH_CONSUMPTION_BY_FILTERS_ERROR: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case CLEAN_CONSUMPTION_DATA: {
      return {
        ...state,
        ...initialState,
      }
    }

    case UPDATE_CONSUMPTION_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload?.partialFilters
        }
      }
    }

    default:
      return state
  }
}

export default consumptionReducer;
